
import ImportWizardV1 from '../import-wizard/import-wizard.vue';
import ImportWizardV2 from '../import-wizard-v2/import-wizard-v2.vue';
import Vue, { PropType } from 'vue';
import { SupportedLangCodes } from '@/constants/languageCodes';
import { ProductPrintPositionAddModel } from '@/typings';
import { LogoOnlyArtwork } from '../import-wizard/typings';
import { CreatePersonalizationFormWrapper } from '../import-wizard/typings/common/createPersonalization';
import isValidLanguageValidator from '@/validators/langLocaleValidator';
import { priceDetails, pdpChoices } from '@/setters';

export default Vue.extend({
  name: 'W2pImportWizardWrapper',
  components: {
    ImportWizardV1,
    ImportWizardV2,
  },
  props: {
    version: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    context: {
      type: String,
      required: false,
      default: '',
    },
    personalizationJson: {
      type: Object as PropType<CreatePersonalizationFormWrapper>,
      required: false,
      default: () => {
        return {} as CreatePersonalizationFormWrapper;
      },
    },
    languageCode: {
      type: String as PropType<SupportedLangCodes>,
      required: false,
      default: 'none',
      validator: isValidLanguageValidator,
    },
    personalizationId: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    productDescription: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    priceDetails,
    wizardOptions: {
      type: Object as PropType<{
        showCurrentVersion: boolean;
        showNextVersion: boolean;
      }>,
      required: false,
    },
    pdpChoices,
    sapCustomerId: {
      type: String,
      required: true,
    },
    endCustomerId: {
      type: String,
      required: false,
    },
    tok: {
      type: String,
      required: true,
    },
    isDirectApproval: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCommunicationSentToCC: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFirstTimeOpened: {
      type: Boolean,
      required: false,
      default: false,
    },
    isConceptDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isOrderDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    printPositions: {
      type: [] as PropType<ProductPrintPositionAddModel[]>,
      required: false,
      default() {
        return [];
      },
    },
    customerCompanyLogoUrl: {
      type: String,
      required: false,
      default: '',
    },
    logoOnlyArtwork: {
      type: [] as PropType<LogoOnlyArtwork[]>,
      required: false,
      default: () => {
        return [];
      },
    },
    sapCustomerEmail: {
      type: String,
      required: false,
      default: '',
    },
    region: {
      type: String,
      required: false,
      default: '',
    },
    userLoginOptions: {
      type: Object as PropType<{ data: string; iv: string }>,
      required: false,
      default: () => {
        return { data: '', iv: '' };
      },
    },
  },
  computed: {
    getVersion() {
      const currentVersion = 'V1';
      const nextVersion = 'V2';

      if (this.version !== undefined && this.version !== '') {
        return this.version;
      }
      if (!this.wizardOptions) {
        return nextVersion;
      }
      if (
        (!this.wizardOptions.showCurrentVersion &&
          this.wizardOptions.showNextVersion) === false
      ) {
        return currentVersion;
      }
      if (
        !this.wizardOptions.showCurrentVersion &&
        this.wizardOptions.showNextVersion
      ) {
        return nextVersion;
      }
      return '';
    },
  },
  methods: {
    // NOTE: Leave, need it for bug fixing
    emitEvent(eventName: string, event: any) {
      if (eventName === 'wizard:price-params-changed') {
        this.$emit('wizard:price-params-changed', event);
      }

      if (eventName === 'wizard:back') {
        this.$emit('wizard:back');
      }

      if (eventName === 'wizard:saved-as-concept') {
        this.$emit('wizard:saved-as-concept', event);
      }

      if (eventName === 'wizard:ordered') {
        this.$emit('wizard:ordered', event);
      }
    },
  },
});
